























import { Component, Prop, Vue } from 'vue-property-decorator';
import { HOST } from '@/global';
import { getImgUrl } from '../utils/dummy';
import TextBlock from './servicestab/TextBlock.vue';
import RichTextBlock from './servicestab/RichTextBlock.vue';
@Component({
  name: 'SingleServiceTab',
  components: {
    text_block: TextBlock,
    richtext_block: RichTextBlock
  }
})
export default class SingleServiceTab extends Vue {
  @Prop() compData: any;
  HOST: string = HOST;
  getImgUrl = getImgUrl;
}
